import * as React from 'react'
import { Masonry, MasonryItem } from 'react-masonry-responsive'
import { Container, Header, Segment, Label, Image, Divider } from 'semantic-ui-react'
import LimitedWithGradient from './LimitedWithGradient'
import { projectsById, ProjectType, projectFilters } from './projectsData'
import Gallery from '../Gallery/Gallery'

const { useState } = React

const Project = ({ project, open }: {project: ProjectType, open: () => void}) =>
<Segment className={project.className} onClick={open}>
  <Image src={project.src} fluid rounded />
  <Label attached='top left'>{project.name}</Label>
  <Label attached='bottom right'>{project.year}</Label>
  {/* <Label attached='top right' color='red'>{project.priority}</Label> */}
</Segment>

const Projects = () => {
  const [selectedFilter, setSelectedFilter] = useState(projectFilters[0])
  const [openedProjectKey, setOpenProjectKey] = useState(null)

  const filters = projectFilters.map((x) =>
    <Label as='a' key={x.name} basic
      className={x.name === selectedFilter.name ? 'active' : ''}
      onClick={() => {setSelectedFilter(x) }}>
      {x.name}
    </Label>)

  const projects = Object.keys(projectsById)
  .map((x) => ({key: x, project: projectsById[x]}))
  .sort((a, b) =>  b.project.year - a.project.year)
  .sort((a, b) =>  - (b.project.priority - a.project.priority))
  .filter((x) => x.project.category === selectedFilter.name || selectedFilter.name === 'Todos')

  const items: MasonryItem[] = projects.map((x) => ({
    key: x.key,
    node: <Project project={x.project} open={() => setOpenProjectKey(x.key)} />,
  }))

  return (
    <Container id='projects'>
      <Header size='huge' textAlign='center'>Projetos</Header>
      <Label.Group className='filters' size='large'>
        {filters}
      </Label.Group>
      <Divider hidden />
      <Gallery
        isOpen={!!openedProjectKey}
        items={openedProjectKey ? projectsById[openedProjectKey].images : []}
        onClose={() => setOpenProjectKey(null)}
        />
      <LimitedWithGradient>
        <Masonry
          items={items}
          minColumnWidth={220}
        />
      </LimitedWithGradient>
    </Container>
  )
}

export default Projects
